<template>
<div class='help'>
    <el-container style="height: 100%;">
    <el-aside width="241px" style="border-right:1px solid #ddd" >
    <el-menu
    class='helpAside'
      :default-active="active"
      @open="handleOpen"
      @close="handleClose"
      router
      >
      <component class="menu-item" v-for="(value) in asideData" :key="value.url"
      :index="'/helpCenter/'+value.url" :is="(value.child&&value.child.length>0)?'el-submenu':'el-menu-item'">
        <template slot="title">
          <span class='asideTitle'>{{value.mc}}</span>
        </template>
        <template v-if="value.child&&value.child.length>0">
          <component class="menu-item" v-for="(v) in value.child" :key="v.url"
            :index="'/helpCenter/'+v.url" :is="(v.child&&v.child.length>0)?'el-submenu':'el-menu-item'">
                <template slot="title">
                    <span>{{v.mc}}</span>
                </template>
                <template v-if="v.child&&v.child.length>0">
                    <component class="menu-item" v-for="(s) in v.child" :key="s.url"
                    :index="'/helpCenter/'+s.url" :is="(s.child&&s.child.length>0)?'el-submenu':'el-menu-item'">
                        <template slot="title">
                        <span>{{s.mc}}</span>
                        </template>
                    </component>
                </template>
            </component>
        </template>
      </component>
    </el-menu>
    </el-aside>
    <el-container>
    <router-view class='helpContent'></router-view>
    </el-container>
    </el-container>
</div>
</template>
<script>
export default {
    name:'center',
    data(){
        return{
            active:'/helpCenter/1.1.1',
            asideData:[
                {mc:'操作手册',
                url:'1',
                    child:[
                        {mc:'报名',
                        url:'1.1',
                        child:[
                            {mc:'选择项目',url:'1.1.1'},
                            {mc:'企业申报',url:'1.1.2'},
                            {mc:'等待审核',url:'1.1.3'},
                            {mc:'项目投标',url:'1.1.4'},
                        ]},
                        {mc:'资格预审',
                        url:'1.2',
                        child:[
                            {mc:'投标邀请函（邀请预审）',url:'1.2.1'},
                            {mc:'资格预审公告',url:'1.2.2'},
                            {mc:'资格预审文件',url:'1.2.3'},
                            {mc:'提疑与获取澄清修改文件（资格预审）',url:'1.2.4'},
                            {mc:'资格预审申请文件递交',url:'1.2.5'},
                            {mc:'资格预审结果通知书',url:'1.2.6'},
                        ]},
                        {mc:'投标',
                        url:'1.3',
                        child:[
                            {mc:'投标邀请函（邀请后审）',url:'1.3.1'},
                            {mc:'招标公告',url:'1.3.2'},
                            {mc:'招标文件',url:'1.3.3'},
                            {mc:'提疑与获取澄清修改文件（招标）',url:'1.3.4'},
                            {mc:'投标文件',url:'1.3.5'},
                        ]},
                        {mc:'定标',
                        url:'1.4',
                        child:[
                            {mc:'中标候选人公示',url:'1.4.1'},
                            {mc:'提异议',url:'1.4.2'},
                            {mc:'中标公告',url:'1.4.3'},
                            {mc:'中标（招标结果）通知书',url:'1.4.4'},
                            {mc:'签署合同',url:'1.4.5'},
                            {mc:'项目履约情况',url:'1.4.6'},
                        ]
                        },
                        {
                            mc:'操作视频',url:'1.5'
                        }
                    ]
                },
                {mc:'常见问题',url:'2'}
            ]
            
        }

    },
    methods:{
        handleOpen(){
        },
        handleClose(){
        }
    },
    mounted(){
        let path=this.$route.path.split('/')[2]
        if(!path){
            this.$router.push('/helpCenter/1.1.1');
        }else{
            this.active=this.$route.path
        }

    }

}
</script>
<style lang="less">
.help{
    background:#fff;
    .el-aside{
        background: #fbfbfb;
    }
    .el-menu{
        border:none;
        background: #fbfbfb;
    }
    .el-submenu .el-menu-item{
        min-width: auto;
        line-height: 20px;
        padding-right:0;
        padding-top:13px;
    }
    .el-menu-item, .el-submenu__title{
        white-space:normal;
    }
    .el-menu-item:focus, .el-menu-item:hover{
        background: transparent;
        color:#cc2729;
    }
    .el-submenu__title:hover{
        background: #fbfbfb;
    }
    .helpAside{
        width: 220px;
        padding:20px 20px 20px 0;
        .asideTitle{
            font-size: 18px;
            color:#333;
            font-weight:bold;
        }
        .el-menu-item.is-active span{
            color:#cc2729;
        }
    }
    .helpContent{
        padding:30px 40px 10px 40px;
        width: 950px;
        margin: 0 auto;
        >div{
            padding:0 10px;
            text-align: center;
            img{
                max-width: 100%;
                margin: 0 auto 40px;
            }
            p{
                font-weight: bold;
                color: #333;
                line-height:24px;
                min-height: 40px;
                font-size: 14px;
                text-align: left;
            }
        }
        p.title{
            font-size: 16px;
            font-weight: bold;
            color: #333;
            line-height: 40px;
            padding-bottom:10px;
        }
    }
}
</style>